import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import {getValueHash} from "../../../../common/utils/array";


const styles = theme => ({
	contentText:{
		marginBottom:15
	},
	fromTo : {
		padding: '9px 15px 0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
		boxSizing:'border-box'
	},
	inputText : {
		flexGrow : 1
	},
	dialogActions:{
		justifyContent:'space-between'
	},
	deleteButton:{
		width:48,
		height:'100%',
		paddingTop:10,
		marginBottom: -10
	}
});

function Transition(props) {
	return <Slide direction="up" {...props} />;
}

const updateHashBase = {from:'',to:''};

class formDialog extends React.Component {

	constructor(props) {
		super(props);
		const conversion = (!props.conversion.length) ? [updateHashBase] : props.conversion;
		this.state = {
			conversion : conversion
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(nextProps.open !== this.props.open){
			const conversion = (!nextProps.conversion.length) ? [updateHashBase] : nextProps.conversion;
			this.setState({
				conversion : conversion
			});
		}
	}

	/** event handlers **/
	handleChange = (event) =>{
		this.setState({
			inputText : event.target.value
		});
	};

	handleClose = () =>{
		const {afterCancelFunc} = this.props;
		if(afterCancelFunc) afterCancelFunc();
	};

	handleSave = () =>{
		const {afterOkFunc} = this.props;
		const conversions = _.filter(this.state.conversion, (conv)=>{
			return conv.from !== ''
		});
		if(afterOkFunc) afterOkFunc(conversions);
	};

	handleChangeFrom = (index,event) =>{
		let conversion = getValueHash(this.state.conversion);

		let updateHash = getValueHash(conversion[index]);
		updateHash.from = event.target.value;
		conversion[index] = updateHash;

		if(conversion.length === index + 1 && (updateHash.from !== '' || updateHash.to !== '')){
			conversion.push(updateHashBase);
		}

		this.setState({
			conversion
		});
	};

	handleChangeTo = (index,event) =>{
		let conversion = getValueHash(this.state.conversion);
		let updateHash = getValueHash(conversion[index]);
		updateHash.to = event.target.value;
		conversion[index] = updateHash;

		if(conversion.length === index + 1 && (updateHash.from !== '' || updateHash.to !== '')){
			conversion.push(updateHashBase);
		}

		this.setState({
			conversion
		});
	};

	handleAddRow = () =>{
		let conversion = getValueHash(this.state.conversion);
		conversion.push(updateHashBase);
		this.setState({
			conversion
		});
	}
	handleRemoveRow = (index) =>{
		let conversion = getValueHash(this.state.conversion);
		conversion.splice(index,1);
		this.setState({
			conversion
		});
	}



	render () {
		const {open, classes} = this.props;
		const {conversion} = this.state;

		const inputRow = (conv, index) =>{
			const fromValue = !(conv) || !("from" in conv) || !(conv.from) ? '' : conv.from;
			const toValue = !(conv) || !("to" in conv) || !(conv.to) ? '' : conv.to;

			return(
				<FormGroup row key={index}>
					<TextField
						margin="dense"
						label="変換前"
						onChange={this.handleChangeFrom.bind(this,index)}
						value={fromValue}
						className={classes.inputText}

					/>
					<div className={classes.fromTo}>-</div>
					<TextField
						margin="dense"
						label="変換後"
						onChange={this.handleChangeTo.bind(this,index)}
						value={toValue}
						className={classes.inputText}

					/>
					<div className={classes.deleteButton}>
						{conversion.length !== 1 &&
						<IconButton className={classes.button} aria-label="行削除" onClick={this.handleRemoveRow.bind(this,index)}>
							<HighlightOffIcon/>
						</IconButton>
						}
					</div>



				</FormGroup>
			)
		};

		return (
			<Dialog
				open={open}
				onClose={this.handleClose}
				aria-labelledby="form-dialog-title"
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				maxWidth={'sm'}
			>
				<DialogTitle id="form-dialog-title">データ変換設定</DialogTitle>
				<DialogContent>
					<DialogContentText>
						データ変換前と変換後の値を設定します
					</DialogContentText>
					{conversion.map((conv,index)=>{
						return(
							inputRow(conv,index)
						)
					})}
				</DialogContent>
				<DialogActions className={classes.dialogActions}>
					<Button onClick={this.handleAddRow} color="primary">
						行追加
					</Button>
					<div>
						<Button onClick={this.handleClose} color="primary">
							キャンセル
						</Button>
						<Button onClick={this.handleSave} color="primary">
							OK
						</Button>
					</div>
				</DialogActions>
			</Dialog>

		);
	}
}
formDialog.propTypes = {
	conversion : PropTypes.array,
	open : PropTypes.bool,
	afterOkFunc : PropTypes.func,
	afterCancelFunc : PropTypes.func
};
formDialog.defaultProps = {
	conversion : []
};
export default withStyles(styles)(formDialog);



// WEBPACK FOOTER //
// ./src/routes/mapping/step3/components/form-dialog.js